import { render, staticRenderFns } from "./beauty.vue?vue&type=template&id=037775ee&scoped=true"
import script from "./beauty.vue?vue&type=script&lang=js"
export * from "./beauty.vue?vue&type=script&lang=js"
import style0 from "./beauty.vue?vue&type=style&index=0&id=037775ee&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037775ee",
  null
  
)

export default component.exports